import { useNavigate } from 'react-router-dom';
import main from '../../main';
import { Goods } from '../../types';
import { findBorderColor, findTagColor } from '../../utils/utils';
interface Props {
  pageNum?: number;
  goods: Goods;
  idx?: number;
}
export default function GridGoodsItem({ pageNum, goods, idx }: Props) {
  const navigate = useNavigate();
  let uc = main.uc;

  function segmentation(price: string) {
    let money = parseFloat(price)?.toFixed(2).split('.');
    return (
      <div className="d-flex-r ai-end ml-2">
        <span className="font-size-18 line-height-18">{money[0]}</span>
        <span className="font-size-10">.{money[1]}</span>
      </div>
    );
  }

  return (
    <div
      className="bg-white box-shadow grid-goods-item d-flex-c mb-10 pos-r"
      onClick={() =>{ 
        if(main?.from){
          window.parent.postMessage({
            type: 'click',
            data:'?code=' + goods.goodsCode + `${uc ? '&uc=' + uc : ''}`
          }, '*');
      
        }else{
          navigate('/product?code=' + goods.goodsCode + `${uc ? '&uc=' + uc : ''}`)
        }
        
      }}
    >
      {pageNum === 1 && idx && idx <= 3 ? (
        <img className="ranking-img pos-a" src={`/pic/icon_popularity0${idx}.png`} alt="" />
      ) : (
        ''
      )}
      <img className="goods-img border-radius-8" src={goods.goodsHeadImg} alt="" />
      <div className="flex-1 d-flex-c pl-10 pr-10 pb-10">
        {!!(goods?.goodsTagClientStyle ?? []).length && (
          <div className="font-size-10 mt-10 d-flex-r flex-wrap h-25 overflow-x">
            {goods?.goodsTagClientStyle.map((item, index) => (
              <div
                key={`${item?.text ?? ''}-${item?.color ?? ''}-${index}`}
                className="p-3 mr-5 d-inline border-radius-4 mb-5"
                style={{
                  color: findTagColor(item?.color),
                  backgroundColor: findBorderColor(item?.color, '0.2'),
                  border: `1px solid ${findBorderColor(item?.color, '0.4')}`,
                }}
              >
                {item?.text}
              </div>
            ))}
          </div>
        )}
        <div className="mt-5 h-40 goods-title omit-text-2 font-size-14 font-widget-500 line-height-20">
          {goods.goodsName}
        </div>
        <div className="d-flex-r ai-end jc-between">
          <div className="d-flex-r ai-end font-widget-500">
            <div className="d-flex-r ai-end text-color-red font-size-10">
              ¥{goods.paySwitch === 'Y' ? segmentation(goods?.goodsPrice.toString() ?? '0') : segmentation('0')}
            </div>
          </div>
          <div className="text-color-9 font-size-10 ml-4">{goods.goodsSales ?? 0}人付款</div>
        </div>
      </div>
    </div>
  );
}
